import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { mPesaLogo } from 'components/ui-kit/Icons/png/index'
// import { RewardsApplepayIcon, RewardsGpayIcon, RewardsMastercardIcon, RewardsSamsungpayIcon } from 'components/ui-kit/Icons/svg/index'
import { usePreLogin } from 'hooks/usePreLogin'

const PaymentSection = ({ redirectPath }) => {
  const { loginData } = useSelector(state => state.auth)
  const { handleRegister } = usePreLogin({ path: redirectPath })
  const { t } = useTranslation()

  return (
    <section className='crypto-won-section payment-section'>
      <div className='theme-card-wrap'>
        <div className='theme-card d-lg-flex align-items-center justify-content-between'>
          <h3 className='my-0'>{t('paymentSectionHeading')}</h3>
          <div className='payment-options'>
            {/* <NavLink to='#'>
              <RewardsMastercardIcon />
            </NavLink>
            <NavLink to='#'>
              <img src={rewardsVisa} alt='Visa' />
            </NavLink>
            <NavLink to='#'>
              <RewardsApplepayIcon />
            </NavLink>
            <NavLink to='#'>
              <RewardsSamsungpayIcon />
            </NavLink> */}
            <NavLink to='#'> Something else here
              <img src={mPesaLogo} alt='M_PESA' style={{ width: '86px', height: '72px' }} />
              {/* <RewardsGpayIcon /> */}
            </NavLink>
          </div>
          {!loginData?.accessToken &&
            <button
              type='button'
              className='btn btn-secondary text-nowrap'
              onClick={handleRegister}
            >{t('signinSignup')}
            </button>}
        </div>
      </div>
    </section>
  )
}

export default React.memo(PaymentSection)
